// React and related imports
import React from 'react';

// Flowbite components
import { Table } from 'flowbite-react';

// Custom components
import { TableCell } from '../../components/Table/Table';
import { EditButton } from '../Shared/EditButton';

// i18 hooks
import { useTranslation } from 'react-i18next';

// Interfaces
import { IAnswer } from '../../common/interfaces/Answer.interface';

interface AnswerTableBodyProps {
  answersList: IAnswer[];
  handleEditAnswer: (answer: IAnswer) => void;
}

export const AnswerTableBody: React.FC<AnswerTableBodyProps> = ({
  answersList,
  handleEditAnswer,
}) => {
  const { t } = useTranslation();

  return (
    <Table.Body>
      {answersList?.map((answer) => (
        <Table.Row key={answer.id} className="bg-white">
          <TableCell>
            {answer?.dataSources?.[0]?.options
              ?.map((opt) => opt?.value?.[0]?.value)
              ?.join(' - ') || t('answers.noOptions')}
          </TableCell>
          <TableCell>
            {answer?.dataSources?.[0]?.options?.filter(
              (opt) => opt?.isCorrect
            )?.[0]?.value?.[0]?.value || t('answers.noCorrectAnswer')}
          </TableCell>
          <TableCell>
            <EditButton onClick={() => handleEditAnswer(answer)} />
          </TableCell>
        </Table.Row>
      ))}
    </Table.Body>
  );
};
